var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIds = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.532,
    height: 24,
    viewBox: "0 0 22.532 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.551 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.654,19.535a.739.739,0,0,1-.739-.739V15.476a3.86,3.86,0,0,1,7.719,0v3.058a.739.739,0,0,1-1.478,0V15.476a2.382,2.382,0,0,0-4.764,0V18.8A.739.739,0,0,1,7.654,19.535Z",
    transform: "translate(2.121 3.87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.314,18.932a.739.739,0,0,1-.739-.739V16.256a6.98,6.98,0,0,1,13.961,0v.78a.739.739,0,0,1-1.478,0v-.78a5.5,5.5,0,0,0-11.005,0v1.936A.739.739,0,0,1,5.314,18.932Z",
    transform: "translate(1.338 3.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.035,16.549a.794.794,0,0,1-.1-.005.741.741,0,0,1-.636-.83,10.1,10.1,0,0,1,19.424-2.33.738.738,0,1,1-1.376.536A8.619,8.619,0,0,0,3.766,15.908.738.738,0,0,1,3.035,16.549Z",
    transform: "translate(0.582 2.311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.577,13.107a.738.738,0,0,1-.663-1.063A13.194,13.194,0,0,1,22.809,9.2a.738.738,0,1,1-1.119.964A11.715,11.715,0,0,0,2.244,12.694.743.743,0,0,1,1.577,13.107Z",
    transform: "translate(0.096 1.531)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29,9.018A.74.74,0,0,1,.736,7.789a16.154,16.154,0,0,1,20.96-2.9.739.739,0,0,1-.805,1.24A14.675,14.675,0,0,0,1.843,8.767.736.736,0,0,1,1.29,9.018Z",
    transform: "translate(0 0.759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.784,4.2a.738.738,0,0,1-.389-1.367A19.225,19.225,0,0,1,17.449.668a.739.739,0,1,1-.392,1.424,17.712,17.712,0,0,0-13.885,2A.74.74,0,0,1,2.784,4.2Z",
    transform: "translate(0.498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.994,19.349a.739.739,0,0,1-.739-.739V14.695a.739.739,0,0,1,1.478,0V18.61A.739.739,0,0,1,9.994,19.349Z",
    transform: "translate(2.902 4.651)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIds);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ids.4a3df75ab215526132940270e91b8431.svg";